import { render, staticRenderFns } from "./AppTable.vue?vue&type=template&id=42045239&scoped=true"
import script from "./AppTable.vue?vue&type=script&lang=js"
export * from "./AppTable.vue?vue&type=script&lang=js"
import style0 from "./AppTable.vue?vue&type=style&index=0&id=42045239&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42045239",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42045239')) {
      api.createRecord('42045239', component.options)
    } else {
      api.reload('42045239', component.options)
    }
    module.hot.accept("./AppTable.vue?vue&type=template&id=42045239&scoped=true", function () {
      api.rerender('42045239', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/External/Shoplazza/components/AppTable.vue"
export default component.exports